import comp from "./AttachmentLoader";
export default comp;
